import AddNewBarCode from "./AddNewBarCode";
export default AddNewBarCode;
